import { CustomContractFunnelItemDto, LoanConfigWithGuaranteeIdsDto } from "api/pricing";
import { pricingAPI } from "services/swagger-api";
import { MainBorrowerPricingState } from "../../types";
import { MainBorrowerPricingSyncActions } from "../types";
import { PricingWatchdog } from "../pricingWatchdog";

export const onSearch = async (
  loans: Array<LoanConfigWithGuaranteeIdsDto>,
  actions: MainBorrowerPricingSyncActions,
  getState: () => MainBorrowerPricingState,
  pricingWatchdog: PricingWatchdog
): Promise<void> => {
  pricingWatchdog.cancel()
  try {
    actions.setPriceLoading(true)
    actions.setError(null)

    const { adjustmentsConfig, borrowerProjectId, borrowerId, loansConfigurations, contractFunnels } = getState()

    // Synchroniser loansConfigurations avec loans (supprimer les IDs manquants)
    const currentLoanIds = loans.map(loan => loan.borrowerLoanId)
    const existingLoanIds = loansConfigurations.map(config => config.insuranceConfig.borrowerLoanId)
    const hasRemovedLoans = existingLoanIds.some(id => !currentLoanIds.includes(id))

    const customContractFunnels: CustomContractFunnelItemDto[] = contractFunnels
      .filter(f => f.hash && f.fees?.length)
      .map(f => ({
        hash: f.hash!,
        fees: f.fees!.map(fee => ({ code: fee.code, value: fee.value }))
      }))

    if (borrowerId && borrowerProjectId) {
      // Appeler le v2/custom-global pour obtenir les funnels avec pricing asynchrone
      const request = {
        selectFunnelsBorrowerCommandDto: {
          riskId: borrowerId,
          borrowerCommission: adjustmentsConfig.borrowerCommission,
          modeLissageFraisIntermediation: adjustmentsConfig.modeLissageFraisIntermediation,
          loans,
          contractFunnels: customContractFunnels
        }
      }
      const response = await pricingAPI.getBorrowerCustomPricingDataV2(request)
      if (response.contractFunnels) {
        if (hasRemovedLoans) {
          actions.syncLoansConfigurations(currentLoanIds)
        }
        actions.updatePendingLoanConfigs(loans)
        actions.updateContractFunnels(response.contractFunnels)
        pricingWatchdog.arm(async () => (await pricingAPI.getBorrowerCustomPricingDataV2(request)).contractFunnels)
      }
    }
  } catch (error) {
    actions.setError(error instanceof Error ? error.message : 'Une erreur est survenue')
  } finally {
    actions.setPriceLoading(false)
  }
}
